// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaMedium, FaTwitter } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-left">
        <span>© {new Date().getFullYear()} Ideal Scribe. All rights reserved.</span>
      </div>
      <nav className="footer-links">
        <Link to="/terms-of-service">Terms of Service</Link>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/support">Support</Link>
        <div className="social-links">
          <a href="https://medium.com/ideal-scribe" target="_blank" rel="noopener noreferrer">
            <FaMedium />
          </a>
          <a href="https://www.facebook.com/profile.php?id=61583794869837" target="_blank" rel="noopener noreferrer">
            <FaFacebook />
          </a>
          <a href="https://www.instagram.com/idealscribe" target="_blank" rel="noopener noreferrer">
            <FaInstagram />
          </a>
          {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
            <FaTwitter />
          </a> */}
        </div>
      </nav>
    </footer>
  );
};

export default Footer;
